const Product = {
    product: () => 'inventory/stocks/v2',
    filter: () => 'inventory/filters',
    productById: (id: string) => `inventory/stocks/v2/${id}`,
    productTypeList: () => `admin/common/product-type`,
    // for heading or lens detail
    lensDetail:()=>'store/staff/additional/lens-details'
}
export default Product
